import { render, staticRenderFns } from "./Minute.vue?vue&type=template&id=06dd7a18"
import script from "./Minute.vue?vue&type=script&lang=js"
export * from "./Minute.vue?vue&type=script&lang=js"
import style0 from "./Minute.vue?vue&type=style&index=0&id=06dd7a18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports